/**
 * Sprowadza wpisany tekst do `XX-XXX`: zostają same cyfry, myślnik wstawia
 * się sam po drugiej. Klawiatura numeryczna na iOS nie ma myślnika, a nikt
 * na telefonie i tak go nie wpisuje.
 */
export const applyPostalCodeMask = (raw: string): string => {
  const digits = raw.replace(/\D/g, '').slice(0, 5);
  return digits.length > 2
    ? `${digits.slice(0, 2)}-${digits.slice(2)}`
    : digits;
};
